import React, { Component } from 'react';
import Slider from 'react-slick';
import ReactPlayer from 'react-player';
import { GlobalContext } from '../shared/GlobalContext';
import * as utils from '../../shared/ClientUtils';

export class MgalleryView extends Component {
  static contextType = GlobalContext;
  state = {};

  deleteImage = (mGalleryId, imageFilepath) => {
    utils.quickPost(
      '/api/data/mGallery/removeImage',
      { mGalleryId, imageFilepath },
      utils.toastAlertFunc,
      'Error deleting image from gallery: ',
      (j) => {
        utils.toastSuccessFunc(
          'SUCCESS',
          'Image deleted from gallery. Will disappear after page refresh.'
        );
        //this.setState({ gallery: j.mGallery });
      }
    );
  };

  addImage = (mGalleryId, imageFile) => {
    utils.fileUpload(
      '/api/file/upload/mGalleryImage',
      { id: mGalleryId },
      imageFile,
      utils.toastAlertFunc,
      'Error uploading file: ',
      () => {
        utils.toastSuccessFunc(
          'SUCCESS',
          'Image added to gallery. Will show up after page refresh.'
        );
      }
    );
  };

  updateGallery = (params) => {
    utils.quickPost(
      '/api/data/mGallery/update',
      params,
      utils.toastAlertFunc,
      'Error deleting video from gallery: ',
      (j) => {
        utils.toastSuccessFunc(
          'SUCCESS',
          'Video deleted from gallery. Will disappear after page refresh.'
        );
        //this.setState({ gallery: j.mGallery });
      }
    );
  };

  render() {
    return (
      <div className='card' style={{ borderWidth: 0 }}>
        <div className='card-body' style={{ margin: 0, padding: 0 }}>
          {(this.state.gallery || this.props.gallery).name && (
            <h4 className='card-title'>
              {(this.state.gallery || this.props.gallery).name}
            </h4>
          )}
          {(this.state.gallery || this.props.gallery).date && (
            <p className='card-text'>
              {new Date(
                (this.state.gallery || this.props.gallery).date
              ).toLocaleDateString()}
            </p>
          )}
          <Slider
            dots={false}
            autoplay={this.props.autoplay}
            autoplaySpeed={this.props.autoplaySpeed || 2000}
            infinite={this.props.infinite}
            slidesToShow={this.props.slidesToShow || 3}
            variableWidth={
              !this.props.fixedWidth && this.props.slidesToShow !== 1
            }
            slidesToScroll={1}
          >
            {(this.state.gallery || this.props.gallery).imageFilepaths.map(
              (path, index) => (
                <div key={path}>
                  <img
                    src={
                      (this.props.pathPrefix || '/api/file/path?path=') + path
                    }
                    alt='galleryImage'
                    loading='lazy'
                    style={
                      this.props.slidesToShow !== 1
                        ? {
                            height: this.props.imageHeight || '200px',
                            paddingLeft: '5px',
                            paddingRight: '5px',
                          }
                        : {
                            width: '90%',
                            marginLeft: '5%',
                            marginRight: '5%',
                            marginTop: '5px',
                          }
                    }
                    onClick={(event) =>
                      this.context.showMultipleImageModal(
                        'Image Viewer',
                        (
                          this.state.gallery || this.props.gallery
                        ).imageFilepaths.map(
                          (p) =>
                            (this.props.pathPrefix || '/api/file/path?path=') +
                            p
                        ),
                        index,
                        (this.state.gallery || this.props.gallery)._id &&
                          this.context.user &&
                          ['SuperAdmin', 'Admin', 'Moderator-mGallery'].some(
                            (role) => this.context.user.roles.includes(role)
                          )
                          ? (imgDeleteIndex) =>
                              this.deleteImage(
                                (this.state.gallery || this.props.gallery)._id,
                                (this.state.gallery || this.props.gallery)
                                  .imageFilepaths[imgDeleteIndex]
                              )
                          : null,
                        (this.state.gallery || this.props.gallery)._id &&
                          this.context.user &&
                          ['SuperAdmin', 'Admin', 'Moderator-mGallery'].some(
                            (role) => this.context.user.roles.includes(role)
                          )
                          ? (imageFilepath) =>
                              this.addImage(
                                (this.state.gallery || this.props.gallery)._id,
                                imageFilepath
                              )
                          : null,
                        'lg'
                      )
                    }
                  />
                </div>
              )
            )}
            {(this.state.gallery || this.props.gallery).videoLinks &&
              (this.state.gallery || this.props.gallery).videoLinks.map(
                (link) => (
                  <div key={link}>
                    <ReactPlayer
                      url={link}
                      width='320px'
                      height='200px'
                      paddingLeft='5px'
                      paddingRight='5px'
                      controls={true}
                    />
                    {(this.state.gallery || this.props.gallery)._id &&
                      this.context.user &&
                      ['SuperAdmin', 'Admin', 'Moderator-mGallery'].some(
                        (role) => this.context.user.roles.includes(role)
                      ) && (
                        <button
                          type='button'
                          className='btn btn-danger'
                          onClick={(event) => {
                            event.preventDefault();
                            const params = {
                              mGalleryId: (
                                this.state.gallery || this.props.gallery
                              )._id,
                            };
                            const videoLinks = (
                              this.state.gallery || this.props.gallery
                            ).videoLinks.slice();
                            const index = videoLinks.findIndex(
                              (lnk) => lnk === link
                            );
                            if (index !== -1) {
                              videoLinks.splice(index, 1);
                              params.videoLinks = videoLinks;
                              this.updateGallery(params);
                            } else {
                              utils.toastAlertFunc(
                                'ERROR',
                                'Invalid video link.'
                              );
                            }
                          }}
                        >
                          DELETE
                        </button>
                      )}
                  </div>
                )
              )}
          </Slider>

          {(this.state.gallery || this.props.gallery).link && (
            <p className='card-text'>
              <a href={(this.state.gallery || this.props.gallery).link}>
                See More
              </a>
            </p>
          )}
        </div>
      </div>
    );
  }
}

export default MgalleryView;
